import type MeetingTypeExtensionResponse from '../services/schema/MeetingTypeExtensionResponse';
import type { PublishingSettingsExtension } from '../store/schema/PublishingSettingsExtension';
import { logUsage } from 'owa-analytics';
import { owaDate } from 'owa-datetime';

import getEntryPoint from '../selectors/getEntryPoint';
import { PUBLISHING_SETTINGS_ID } from '../selectors/getPublishSettingsVariables';
import getMeetingTypeExtension from '../services/getMeetingTypeExtension';
import updateMeetingTypeExtension from '../services/updateMeetingTypeExtension';
import store from '../store/Store';
import { getUserMailboxGuid } from './getMailboxGuid';
import getMailboxPuid from '../selectors/getMailboxPuid';

import type MeetingTypeExtension from '../services/schema/MeetingTypeExtension';
/*
Util function to set isPublishedForAttendee in the backend so we can track
whether the attendee page is published.
*/
const PUBLISHING_SETTINGS_NAME: string = 'PUBLISHING_SETTINGS';
export default async function setIsPublishedForAttendee() {
    await getMeetingTypeExtension(PUBLISHING_SETTINGS_ID).then(
        async (response: MeetingTypeExtensionResponse | null) => {
            if (response != null && response.additionalInformation) {
                const publishingSettingsExtension: PublishingSettingsExtension = JSON.parse(
                    response.additionalInformation
                );
                const nowUtc = owaDate();
                const newPublishingSettingsExtension: PublishingSettingsExtension = {
                    isPublishedForAttendee: true,
                    attendeeAndOrganizerPublishSyncTime: nowUtc,
                    isPublished: true,
                    whenLastUpdated: nowUtc,
                    whenSettingsCreated: publishingSettingsExtension.whenSettingsCreated,
                };
                const publishingSettingsExtensionAdditionalInformation = JSON.stringify(
                    newPublishingSettingsExtension
                );
                const publishingSettingsRequestBody: MeetingTypeExtension = {
                    itemId: PUBLISHING_SETTINGS_ID,
                    displayName: PUBLISHING_SETTINGS_NAME,
                    isPrivate: true,
                    recipients: [],
                    additionalInformation: publishingSettingsExtensionAdditionalInformation,
                    preBuffer: store.meetingTypeEditState.preBuffer,
                    postBuffer: store.meetingTypeEditState.postBuffer,
                    excludeFromSelfService: store.meetingTypeEditState.excludeFromSelfService,
                };
                logUsage('setIsPublishedForAttendee', {
                    newPublishingSettingsExtension:
                        publishingSettingsExtensionAdditionalInformation,
                    entryPoint: getEntryPoint(),
                    mailboxGuid: getUserMailboxGuid(),
                    bookingMailboxPuid: getMailboxPuid(),
                });
                await updateMeetingTypeExtension(publishingSettingsRequestBody);
            }
        }
    );
}
